var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button button--action button--compare",attrs:{"type":"button"}},[_c('svg-icon',{staticClass:"button__icon",attrs:{"name":"icon-compare"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }